// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1H22T","label":"Radio_label__iv3j0","checkMark":"Radio_checkMark__3zM_W","disabled":"Radio_disabled__1TyaF"};